/**
 * @file
 * @copyright  2017 Subscribe-HR
 */

import StringField from './StringField';

/**
 * Subscribe-HR entity email field
 */
export default class Email extends StringField {
}



// WEBPACK FOOTER //
// ./src/client/common/js-subscribe-sdk/lib/Fields/Email.js